import {
    LICENCE_CATEGORY,
    OTHER_DETAILS,
    FOREIGN_COMPANY_DETAILS,
    STATION_EQUIPMENT_INFORMATION,
    SUPPORTING_DOCUMENTS
} from '../../../../common/application.const/Licence/MyLicence/TFLicence';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

export const formatTF = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;

    newDocs = [];

    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    for (const key in licenceDetails.supportingDocuments) {
        if (licenceDetails.supportingDocuments.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.supportingDocuments[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    licence = {
        id: 'technical-trial-without-use-of-frequency',
        formID: 'technical-trial-without-use-of-frequency',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${LICENCE_CATEGORY}-licence-category`]: licenceDetails?.LicenceCategoryDetails?.pleaseSelectTheLicenceYouWishToApply ?? '-',

            [`${OTHER_DETAILS}-proposed-used-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystemEquipment ?? '-',
            [`${OTHER_DETAILS}-remarks`]: licenceDetails?.otherDetails?.remarks ?? '-',

            [`${FOREIGN_COMPANY_DETAILS}-foreign-company-name`]: licenceDetails?.organisationInformation?.companyName ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-address-line-1`]: licenceDetails?.organisationInformation?.address?.foreignAddress1 ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-address-line-2`]: licenceDetails?.organisationInformation?.address?.foreignAddress2 ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-address-line-3`]: licenceDetails?.organisationInformation?.address?.foreignAddress3 ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-address-line-4`]: licenceDetails?.organisationInformation?.address?.foreignAddress4 ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-address-line-5`]: licenceDetails?.organisationInformation?.address?.foreignAddress5 ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-email`]: licenceDetails?.organisationInformation?.email ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-contact-number`]: licenceDetails?.organisationInformation?.telNumber ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-city`]: licenceDetails?.organisationInformation?.address?.city ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-state`]: licenceDetails?.organisationInformation?.address?.state ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-zip-code`]: licenceDetails?.organisationInformation?.address?.zipCode ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-country`]: licenceDetails?.organisationInformation?.address?.country ?? '-',

            [`${STATION_EQUIPMENT_INFORMATION}-station-equipment-name`]: licenceDetails?.StationInformationPage?.stationName ?? '-',
            [`${STATION_EQUIPMENT_INFORMATION}-purpose-and-objectives`]:
                licenceDetails?.StationInformationPage?.purposeAndObjectives ?? '-',

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    return licence;
};

const tfPayload = {
    formatTF
};

export default tfPayload;
